import React from 'react';
import CopyrightIcon from '@material-ui/icons/Copyright';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  footer: {
    width: '100%',
    display: 'block',
    textAlign: 'center',
    paddingTop: '24px',
    paddingBottom: '24px',
  },
  footerText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: 0,
  },
}));

/**
 * Render
 */
export default function Footer() {
  const classes = useStyles();
  const year = new Date().getFullYear();
  return (
    <footer className={classes.footer}>
      <p className={classes.footerText}>
        <CopyrightIcon style={{ fontSize: 12, marginRight: 2 }} /> {year}{' '}
        TimeTable-Scheduler v1
      </p>
    </footer>
  );
}
